import { Divider, Title } from "../../styles";
import { Container, CreatorContainer, CreatorSteps, Wrapper } from "./styles";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import Layout from "./1-Layout";
import Images from "./2-Images";
import LayoutTextForm from "./3-Text";
import Preview from "./4-Preview";
import {
  getGeneratedImages,
  ResetCreatorAI,
} from "../../../../redux/modules/AI_Creator/actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const items = [
  {
    title: <FormattedMessage id={"ai_creator.tab1"} />,
  },
  {
    title: <FormattedMessage id={"ai_creator.tab2"} />,
  },
  {
    title: <FormattedMessage id={"ai_creator.tab3"} />,
  },
  {
    title: <FormattedMessage id={"ai_creator.tab4"} />,
  },
];

export default function CreateMediaKit() {
  const history = useHistory();
  const [activeStep, setActiveStep] = useState(0);
  const dispatch = useDispatch();
  const {
    generatedImages: generatedImagesRedux,
    remainingAttempts,
    hasAccess,
  } = useSelector((state) => state.ai_creator);
  const { contract } = useSelector((state) => state.initialSettings);
  const loadedContractRef = useRef(null);

  // step 1
  const [layout, setLayout] = useState({
    layout: null,
    color: null,
  });

  // step 2
  const [selectImageType, setSelectedImageType] = useState(null);
  const [confirmedImage, setConfirmedImage] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [uploadImgUrl, setUploadImgUrl] = useState(null);
  const [generatedImages, setGeneratedImages] = useState([]);

  // step 3
  const [logoSrc, setLogoSrc] = useState(null);
  const [logoFileList, setLogoFileList] = useState([]);
  const [texts, setTexts] = useState({
    primaryText: "",
    secondaryText: "",
    callText: "",
  });

  useEffect(() => {
    if (loadedContractRef.current !== contract?.value) {
      loadedContractRef.current = contract?.value;
      setGeneratedImages([]);
      dispatch(getGeneratedImages());
    }
  }, [dispatch, contract?.value]);

  useEffect(() => {
    if (generatedImagesRedux.length > 0) {
      setGeneratedImages((prev) => {
        // Se prev está vazio (resetado ao trocar contrato), substitui completamente
        if (prev.length === 0) {
          return generatedImagesRedux;
        }
        // Senão, combina e remove duplicatas
        const combined = [...prev, ...generatedImagesRedux];
        const unique = combined.filter(
          (img, index, self) =>
            index === self.findIndex((t) => t.src === img.src),
        );
        return unique;
      });
    } else {
      setGeneratedImages(generatedImagesRedux);
    }
  }, [generatedImagesRedux]);

  useEffect(() => {
    if (!hasAccess) {
      dispatch(ResetCreatorAI());
      history.push("/checklist");
    }
  }, [hasAccess, dispatch, history]);

  const handleChangeStep = (key) => {
    setActiveStep(key);
  };

  return (
    <Container>
      <CreatorContainer>
        <Wrapper>
          <Title>
            <FormattedMessage id={"sidebar.creator"} />
          </Title>

          <CreatorSteps current={activeStep} items={items} />
          <Divider animated margin="16px 0" />

          {activeStep === 0 && (
            <Layout
              nextStep={() => handleChangeStep(1)}
              setLayout={setLayout}
              defaultColor={layout.color}
            />
          )}

          {activeStep === 1 && (
            <Images
              nextStep={() => handleChangeStep(2)}
              previousStep={() => handleChangeStep(0)}
              layout={layout}
              setConfirmedImage={setConfirmedImage}
              setFileList={setFileList}
              setSelected={setSelectedImageType}
              select={selectImageType}
              fileList={fileList}
              confirmedImage={confirmedImage}
              uploadImgUrl={uploadImgUrl}
              setUploadImgUrl={setUploadImgUrl}
              setGeneratedImages={setGeneratedImages}
              generatedImages={generatedImages}
              remainingAttempts={remainingAttempts}
            />
          )}

          {activeStep === 2 && (
            <LayoutTextForm
              nextStep={() => handleChangeStep(3)}
              previousStep={() => handleChangeStep(1)}
              layout={layout}
              confirmedImage={confirmedImage}
              setTexts={setTexts}
              texts={texts}
              logoSrc={logoSrc}
              setLogoSrc={setLogoSrc}
              setLogoFileList={setLogoFileList}
              logoFileList={logoFileList}
            />
          )}

          {activeStep === 3 && (
            <Preview
              logoSrc={logoSrc}
              previousStep={() => handleChangeStep(2)}
              layout={layout}
              confirmedImage={confirmedImage}
              texts={texts}
            />
          )}
        </Wrapper>
      </CreatorContainer>
    </Container>
  );
}
